import {HostingPhpConfig} from "./hosting-php-config";

export class HostingPhpConfigMapper {

  public static map(data: any): HostingPhpConfig {
    const phpConfig: HostingPhpConfig = new HostingPhpConfig();
    phpConfig.maxExecutionTime = data.max_execution_time;
    phpConfig.memoryLimit = data.memory_limit;
    phpConfig.postMaxSize = data.post_max_size;
    phpConfig.uploadMaxFilesize = data.upload_max_filesize;
    return phpConfig;
  }

}
